export default {
    title: 'removeFormat',
    action: [ 'removeFormat' ],
    description: 'Remove formatting.\nClears headings, bold, italic, underlined text, etc.',
    icon: 'Clear',
};
